// helpers.ts

export const isGif = (productType: string): boolean => {
    return productType.includes('GIF');
};

export const isMpip = (productType: string): boolean => {
    return productType.includes('MPIP');
};
